import type { AnswerValue, Question, Section } from '../../types/types';
import QuestionRenderer from './QuestionRenderer';

interface SectionViewerProps {
  section: Section;
  errors?: Record<string, string>;
  answers: Record<string, AnswerValue>;
  onAnswerChange: (questionId: string, value: AnswerValue) => void;
  savingAnswer?: boolean;
  completed?: boolean;
}

function isConditionMet(
  question: Question,
  answers: Record<string, AnswerValue>,
): boolean {
  const condition = question.condition;
  const hidden = question.hidden;

  if (!condition || !hidden) return true; // no condition → always show

  const dependencyId = condition.depends_on || condition.question_id;
  if (!dependencyId) return true;

  const currentValue = answers[dependencyId];
  return currentValue === condition.value;
}

export default function SectionViewer({
  section,
  answers,
  errors = {},
  onAnswerChange,
  savingAnswer,
  completed,
}: SectionViewerProps) {
  return (
    <div>
      {section.questions.map((q: Question, indx: number) => {
        const shouldRender = isConditionMet(q, answers);

        if (!shouldRender) return null;

        const error = errors[q.id];
        const hasError = Boolean(error);

        return (
          <div key={q.id} className="mb-5">
            <QuestionRenderer
              question={q}
              error={hasError}
              value={answers[q.id]}
              onChange={(val: AnswerValue) => {
                onAnswerChange(q.id, val);
              }}
              questionIndex={indx}
              savingAnswer={savingAnswer}
              completed={completed}
            />
            {hasError && (
              <div className="text-danger small mt-1 position-absolute">
                {error}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// import type { Section } from '../../types/types';
// import QuestionRenderer from './QuestionRenderer';

// interface SectionViewerProps {
//   section: Section;
//   answers: Record<string, AnswerValue>;
//   errors?: Record<string, string>;
//   onAnswerChange: (
//     questionId: string,
//     value: AnswerValue,
//     questionKey: string
//   ) => void;
// }

// export default function SectionViewer({
//   section,
//   answers,
//   errors = {},
//   onAnswerChange,
// }: SectionViewerProps) {
//   return (
//     <div>
//       {section.questions.map((q, indx) => {
//         const error = errors[q.key];
//         const hasError = Boolean(error);

//         return (
//           <div
//             key={q.id}
//             className={`mb-4 p-2 rounded ${
//               hasError ? 'border border-danger' : ''
//             }`}
//           >
//             <QuestionRenderer
//               question={q}
//               value={answers[q.key]}
//               error={error} // ✅ pass error
//               onChange={(val) => onAnswerChange(q.id, val, q.key)}
//               questionIndex={indx}
//             />
//             {hasError && <div className="text-danger small mt-1">{error}</div>}
//           </div>
//         );
//       })}
//     </div>
//   );
// }
